<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <div class="row pb-4">
            <div class="col">
              <h3 class="p-0">HHG Rates Filing Administration</h3>
            </div>
            <div class="col text-right">
              <div class="dropdown">
                <button type="button" class="btn btn-outline-secondary btn-more w-auto rounded-circle" id="more-options" data-toggle="dropdown" aria-label="More Options" aria-haspopup="true" aria-expanded="false">
                  <span class="ellipsis" aria-hidden="true">&#8943;</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <h6 class="dropdown-header text-uppercase px-4">More Options</h6>
                  <a class="dropdown-item" routerLink="/ratefiletspext" routerLinkActive="active">Extend Closing Date</a>
                </div>
              </div>
            </div>
          </div>

          @if (updateSuccessful && (this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing')) {
            <div class="alert alert-success">
              Your Rate Filing dates have been successfully updated.
            </div>
          }
          @if (updateSuccessful && (this.rateFileOpenForm.get('rateKind').value === 'Rate Effective Dates')) {
            <div class="alert alert-success">
              Your Rate Effective Dates have been successfully updated.
            </div>
          }
          @if (updateSuccessful && (this.rateFileOpenForm.get('rateKind').value === 'TSP Participation')) {
            <div class="alert alert-success">
              Your TSP Participation dates have been successfully updated.
            </div>
          }
          @if (updateFailure) {
            <div class="alert alert-danger">
              An error has occurred. Please contact support.
            </div>
          }

          <form [formGroup]="rateFileOpenForm" >
            <div class="form-row">
              @if (this.rateFileOpenForm.get('rateType').value ==='FRT') {
                <div class="form-group col-md-4">
                  <label for="rate_kind">Rate Kind</label>
                  <select id="rate_kind" class="w-100" formControlName="rateKind"  (change)="changeRateKind($event)">
                    <option value="null">Choose...</option>
                    @for (frtoption of frtOptions; track frtoption) {
                      <option [value]="frtoption.value">{{frtoption.name}}</option>
                    }
                  </select>
                </div>
              }
              @if (this.rateFileOpenForm.get('rateType').value ==='HHG') {
                <div class="form-group col-md-4">
                  <label for="rate_kind">Rate Kind</label>
                  <select id="rate_kind" class="w-100" formControlName="rateKind"  (change)="changeRateKind($event)">
                    <option value="null">Choose...</option>
                    @for (hhgoption of hhgOptions; track hhgoption) {
                      <option [value]="hhgoption.value">{{hhgoption.name}}</option>
                    }
                  </select>
                </div>
              }
            </div>
            @if (this.rateFileOpenForm.get('rateType').value !== null && this.rateFileOpenForm.get('rateKind').value !== null) {
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="open_date">Open Date</label>
                  <input type="text" id="open_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="openDate"
                    (bsValueChange)="openDateChange($event)" [minDate]="openMinDate"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    [value]="this.rateFileOpenForm.get('openDate').value | date: 'MMM d, y'"
                    bsDatepicker placement="right"
                    >
                  @if (this.rateFileOpenForm.get('openDate').invalid && this.rateFileOpenForm.get('openDate').touched || this.rateFileOpenForm.get('openDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('openDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> Open Date is required
                        </div>
                      }
                    </div>
                  }
                  @if (this.rateFileOpenForm.get('openDate').invalid &&
                    this.rateFileOpenForm.get('openDate').touched ||
                    this.rateFileOpenForm.get('openDate').dirty) {
                    <div>
                      @if (this.openDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{openDateErrorMsg1}}
                        </div>
                      }
                      @if (this.openDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{openDateErrorMsg2}}
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="form-group col-md-4">
                  <label for="close_date">Close Date</label>
                  <input type="text" id="close_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="closeDate" (bsValueChange)="closeDateChange($event)"
                    [minDate]="closeMinDate" [value]="this.rateFileOpenForm.get('closeDate').value | date: 'MMM d, y'"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    bsDatepicker [bsConfig]="datePickerConfig" placement="right"
                    >
                  @if (this.rateFileOpenForm.get('closeDate').invalid &&
                    this.rateFileOpenForm.get('closeDate').touched ||
                    this.rateFileOpenForm.get('closeDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('closeDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> Close Date is required
                        </div>
                      }
                      @if (this.closeDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{closeDateErrorMsg1}}
                        </div>
                      }
                      @if (this.closeDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{closeDateErrorMsg2}}
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing') {
                  <div class="form-group col-md-4">
                    <label for="release_to_prod">Release to Production</label>
                    <input type="text" id="release_to_prod" class="w-100"
                      [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                      placeholder="mm/dd/yyyy" formControlName="releaseDate" [value]="this.rateFileOpenForm.get('releaseDate').value | date: 'MMM d, y'" bsDatepicker [bsConfig]="datePickerConfig" placement="left"
                      >
                    @if (this.rateFileOpenForm.get('releaseDate').invalid && this.rateFileOpenForm.get('releaseDate').touched || this.rateFileOpenForm.get('releaseDate').dirty) {
                      <div>
                        @if (this.rateFileOpenForm.get('releaseDate').hasError('required')) {
                          <div class="text-danger">
                            <span class="fa fa-warning"></span> Release Date is required
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (this.rateFileOpenForm.get('rateType').value === 'FRT' && this.rateFileOpenForm.get('rateKind').value !== null) {
              <div class="form-row" >
                <div class="form-group col-md-4">
                  <label for="bidCycle">Bid Cycle Name</label>
                  <input type="text" id="bidCycle" class="w-100" formControlName="bidCycle"
                    >
                  @if (this.rateFileOpenForm.get('bidCycle').invalid && this.rateFileOpenForm.get('bidCycle').touched || this.rateFileOpenForm.get('bidCycle').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('bidCycle').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> Bid Cycle Name is required
                        </div>
                      }
                    </div>
                  }
                  <input type="text" class="d-none" formControlName="controlId">
                  <input type="text" class="d-none" formControlName="rateKey">
                </div>
              </div>
            }
            @if ((this.rateFileOpenForm.get('openDate').value !== '' || this.rateFileOpenForm.get('closeDate').value !== '' || this.rateFileOpenForm.get('releaseDate').value !== '') && this.rateFileOpenForm.get('rateType').value !== null && this.rateFileOpenForm.get('rateKind').value !== null) {
              <div class="mt-4">
                <div class="mt-4">
                  <button type="button" class="btn btn-primary w-auto" [disabled]="this.rateFileOpenForm.invalid || this.updateSuccessful || this.buttonDisable || this.validationError" (click)="SaveRateFileRec()">Save</button>
                  <button type="button" class="btn btn-outline-secondary w-auto ml-4 " [disabled]="(this.rateFileOpenForm.get('openDate').value === '' || this.rateFileOpenForm.get('closeDate').value === '' || this.rateFileOpenForm.get('releaseDate').value === '')" (click)="clearPage()">Cancel</button>
                  <button type="button" class="btn btn-primary w-auto ml-4 " (click)="goBack()">Back</button>
                </div>
              </div>
            }
          </form>
        </div>
      </div>
      @if (this.rateFileOpenForm.get('rateType').value !== null && this.rateFileOpenForm.get('rateKind').value !== null) {
        <div class="card shadow-sm mt-5">
          <div class="card-body p-5">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Open Date</th>
                  <th>Close Date</th>
                  @if (this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing') {
                    <th>Release to Production</th>
                  }
                  @if (this.rateFileOpenForm.get('rateType').value === 'FRT') {
                    <th>Bid Cycle Name</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (rateFileDetail of rateFileDetails; track rateFileDetail; let i = $index) {
                  <tr>
                    <!--
                    <td *ngIf = "i == 0"><a  [routerLink]="" (click)="selectedRecord(rateFileDetail.controlId, i)">{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</a></td>
                    <td *ngIf = "i != 0">{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</td>
                    -->
                    <td><a  [routerLink]="[]"  (click)="selectedRecord(rateFileDetail.controlId, i)"
                    >{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</a></td>
                    <td>{{rateFileDetail.expiryDate | date: 'M/d/y'}}</td>
                    @if (this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing') {
                      <td>{{rateFileDetail.releaseDate | date: 'M/d/y'}}</td>
                    }
                    @if (this.rateFileOpenForm.get('rateType').value === 'FRT') {
                      <td>{{rateFileDetail.cycleName}}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>

